import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, Teleport as _Teleport, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "p-6 max-h-[72vh] overflow-y-auto"
};
const _hoisted_2 = {
  key: 0,
  class: "flex items-center justify-center py-8"
};
const _hoisted_3 = {
  class: "flex items-center gap-2 mb-4"
};
const _hoisted_4 = {
  key: 0,
  class: "px-2 py-0.5 bg-red-100 text-red-700 text-xs rounded-full"
};
const _hoisted_5 = {
  class: "text-xl font-semibold text-slate-900 mb-2"
};
const _hoisted_6 = {
  class: "text-sm text-slate-600 mb-4"
};
const _hoisted_7 = {
  class: "space-y-3"
};
const _hoisted_8 = {
  class: "flex items-center gap-3 text-sm"
};
const _hoisted_9 = {
  class: "flex items-center gap-3 text-sm"
};
const _hoisted_10 = {
  class: "text-slate-800"
};
const _hoisted_11 = {
  key: 0,
  class: "flex items-center gap-3 text-sm"
};
const _hoisted_12 = {
  class: "text-slate-800"
};
const _hoisted_13 = {
  class: "mt-6 border-t border-slate-200 pt-5"
};
const _hoisted_14 = {
  class: "flex items-center justify-between mb-3"
};
const _hoisted_15 = {
  class: "flex items-center gap-2"
};
const _hoisted_16 = {
  class: "text-xs text-slate-500"
};
const _hoisted_17 = {
  key: 0,
  class: "space-y-3 max-h-56 overflow-y-auto pr-1"
};
const _hoisted_18 = {
  class: "flex items-center justify-between gap-3 mb-2"
};
const _hoisted_19 = {
  class: "text-sm font-medium text-slate-800"
};
const _hoisted_20 = {
  class: "text-xs text-slate-500 shrink-0"
};
const _hoisted_21 = {
  class: "text-sm text-slate-700 whitespace-pre-wrap break-words"
};
const _hoisted_22 = {
  key: 1,
  class: "rounded-lg border border-dashed border-slate-200 py-5 text-center text-sm text-slate-500"
};
const _hoisted_23 = {
  key: 0,
  class: "px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
const _hoisted_24 = {
  class: "px-6 py-4 border-b border-slate-200 flex items-center justify-between"
};
const _hoisted_25 = ["disabled"];
const _hoisted_26 = {
  class: "p-6"
};
const _hoisted_27 = {
  class: "mt-2 flex justify-end"
};
const _hoisted_28 = {
  class: "text-xs text-slate-500"
};
const _hoisted_29 = {
  class: "px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
const _hoisted_30 = ["disabled"];
const _hoisted_31 = ["disabled"];
const _hoisted_32 = {
  key: 0,
  class: "w-4 h-4 animate-spin",
  fill: "none",
  viewBox: "0 0 24 24"
};
import { ref, computed, watch } from 'vue';
import { todoApi } from '@/api/todo';
import { ElMessage } from 'element-plus';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'TodoDetailModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: null
    }
  },
  emits: ['close', 'complete'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const loading = ref(false);
    const annotationContent = ref('');
    const annotationSubmitting = ref(false);
    const showAnnotationDialog = ref(false);

    // 用于显示的详情数据，优先使用 fetchDetail 获取的完整数据
    const displayItem = computed(() => detailItem.value || props.item);
    const annotations = computed(() => displayItem.value?.annotations || []);

    // 优先级映射
    const priorityMap = {
      1: {
        label: '低',
        class: 'px-2 py-0.5 bg-slate-100 text-slate-700 text-xs rounded-full'
      },
      2: {
        label: '中',
        class: 'px-2 py-0.5 bg-blue-100 text-blue-700 text-xs rounded-full'
      },
      3: {
        label: '高',
        class: 'px-2 py-0.5 bg-amber-100 text-amber-700 text-xs rounded-full'
      },
      4: {
        label: '紧急',
        class: 'px-2 py-0.5 bg-red-100 text-red-700 text-xs rounded-full'
      }
    };

    // 状态映射
    const statusMap = {
      'PENDING': {
        label: '待办',
        class: 'px-2 py-0.5 bg-amber-100 text-amber-700 text-xs rounded-full'
      },
      'IN_PROGRESS': {
        label: '进行中',
        class: 'px-2 py-0.5 bg-blue-100 text-blue-700 text-xs rounded-full'
      },
      'COMPLETED': {
        label: '已完成',
        class: 'px-2 py-0.5 bg-green-100 text-green-700 text-xs rounded-full'
      },
      'OVERDUE': {
        label: '已逾期',
        class: 'px-2 py-0.5 bg-red-100 text-red-700 text-xs rounded-full'
      },
      'cancelled': {
        label: '已取消',
        class: 'px-2 py-0.5 bg-slate-100 text-slate-700 text-xs rounded-full'
      }
    };

    // 获取优先级标签
    function getPriorityLabel(priority) {
      return priorityMap[priority]?.label || '未知';
    }

    // 获取优先级徽章类
    function getPriorityBadgeClass(priority) {
      return priorityMap[priority]?.class || priorityMap[2].class;
    }

    // 获取状态标签
    function getStatusLabel(status) {
      return statusMap[status]?.label || '未知';
    }

    // 获取状态徽章类
    function getStatusBadgeClass(status) {
      return statusMap[status]?.class || statusMap['PENDING'].class;
    }

    // 格式化日期
    function formatDate(dateStr) {
      if (!dateStr) return '未设置';
      const datePart = dateStr.includes('T') ? dateStr.split('T')[0] : dateStr.substring(0, 10);
      return datePart;
    }

    // 格式化日期时间
    function formatDateTime(dateStr) {
      if (!dateStr) return '-';
      const datePart = dateStr.includes('T') ? dateStr.split('T')[0] : dateStr.substring(0, 10);
      const timePart = dateStr.includes('T') ? dateStr.split('T')[1]?.substring(0, 5) : '';
      return timePart ? `${datePart} ${timePart}` : datePart;
    }

    // 关闭弹窗
    function close() {
      closeAnnotationDialog();
      emit('close');
    }

    // 完成待办
    async function handleComplete() {
      if (!props.item) return;
      try {
        await todoApi.complete(props.item.id);
        ElMessage.success('已完成');
        emit('complete');
        close();
      } catch (error) {
        console.error('完成待办失败:', error);
        ElMessage.error(error.message || '操作失败');
      }
    }

    // 添加批注
    async function handleAddAnnotation() {
      const todoId = displayItem.value?.id;
      const content = annotationContent.value.trim();
      if (!todoId || !content) return;
      annotationSubmitting.value = true;
      try {
        await todoApi.addAnnotation(todoId, {
          content
        });
        annotationContent.value = '';
        showAnnotationDialog.value = false;
        ElMessage.success('批注已添加');
        await fetchDetail();
      } catch (error) {
        console.error('添加批注失败:', error);
        ElMessage.error(error.message || '添加批注失败');
      } finally {
        annotationSubmitting.value = false;
      }
    }
    function openAnnotationDialog() {
      annotationContent.value = '';
      showAnnotationDialog.value = true;
    }
    function closeAnnotationDialog() {
      if (annotationSubmitting.value) return;
      showAnnotationDialog.value = false;
      annotationContent.value = '';
    }

    // 详情数据
    const detailItem = ref(null);

    // 加载详情数据
    async function fetchDetail() {
      if (!props.item?.id) return;
      loading.value = true;
      try {
        const res = await todoApi.getDetail(props.item.id);
        if (res) {
          detailItem.value = res;
        }
      } catch (error) {
        console.error('获取待办详情失败:', error);
        ElMessage.error('加载详情失败');
      } finally {
        loading.value = false;
      }
    }

    // 监听弹窗显示
    watch(() => props.show, val => {
      if (val && props.item?.id) {
        fetchDetail();
      } else if (!val) {
        detailItem.value = null;
        closeAnnotationDialog();
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [(_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(_Transition, {
        name: "modal"
      }, {
        default: _withCtx(() => [_createVNode(AppModal, {
          visible: __props.show,
          size: "2xl",
          scrollable: false,
          "panel-class": "mx-4",
          onClose: close
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "px-6 py-4 border-b border-slate-200 flex items-center justify-between"
          }, [_cache[2] || (_cache[2] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "待办详情", -1)), _createElementVNode("button", {
            onClick: close,
            class: "p-1.5 text-slate-400 hover:text-slate-600"
          }, [...(_cache[1] || (_cache[1] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_1, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[3] || (_cache[3] = [_createElementVNode("svg", {
            class: "w-6 h-6 animate-spin text-primary-500",
            fill: "none",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("circle", {
            class: "opacity-25",
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            "stroke-width": "4"
          }), _createElementVNode("path", {
            class: "opacity-75",
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          })], -1)]))])) : displayItem.value ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", {
            class: _normalizeClass(getPriorityBadgeClass(displayItem.value.priority))
          }, _toDisplayString(displayItem.value.priorityDesc || getPriorityLabel(displayItem.value.priority)), 3), _createElementVNode("span", {
            class: _normalizeClass(getStatusBadgeClass(displayItem.value.status))
          }, _toDisplayString(displayItem.value.statusDesc || getStatusLabel(displayItem.value.status)), 3), displayItem.value.overdue ? (_openBlock(), _createElementBlock("span", _hoisted_4, "逾期")) : _createCommentVNode("", true)]), _createElementVNode("h4", _hoisted_5, _toDisplayString(displayItem.value.title), 1), _createElementVNode("p", _hoisted_6, _toDisplayString(displayItem.value.description || '暂无描述'), 1), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_cache[4] || (_cache[4] = _createElementVNode("svg", {
            class: "w-5 h-5 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
          })], -1)), _cache[5] || (_cache[5] = _createElementVNode("span", {
            class: "text-slate-600"
          }, "到期时间：", -1)), _createElementVNode("span", {
            class: _normalizeClass(['text-slate-800', displayItem.value.overdue ? 'text-red-600' : ''])
          }, _toDisplayString(formatDate(displayItem.value.dueDate)), 3)]), _createElementVNode("div", _hoisted_9, [_cache[6] || (_cache[6] = _createElementVNode("svg", {
            class: "w-5 h-5 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          })], -1)), _cache[7] || (_cache[7] = _createElementVNode("span", {
            class: "text-slate-600"
          }, "创建时间：", -1)), _createElementVNode("span", _hoisted_10, _toDisplayString(formatDateTime(displayItem.value.createTime)), 1)]), displayItem.value.completeTime ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_cache[8] || (_cache[8] = _createElementVNode("svg", {
            class: "w-5 h-5 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          })], -1)), _cache[9] || (_cache[9] = _createElementVNode("span", {
            class: "text-slate-600"
          }, "完成时间：", -1)), _createElementVNode("span", _hoisted_12, _toDisplayString(formatDateTime(displayItem.value.completeTime)), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_cache[10] || (_cache[10] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900"
          }, "批注", -1)), _createElementVNode("span", _hoisted_16, _toDisplayString(annotations.value.length) + " 条", 1)]), _createElementVNode("button", {
            type: "button",
            onClick: openAnnotationDialog,
            class: "px-3 py-1.5 bg-primary-700 text-white text-sm rounded-lg hover:bg-primary-800 inline-flex items-center gap-2"
          }, [...(_cache[11] || (_cache[11] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          })], -1), _createTextVNode(" 添加批注 ", -1)]))])]), annotations.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(annotations.value, annotation => {
            return _openBlock(), _createElementBlock("div", {
              key: annotation.id,
              class: "rounded-lg border border-slate-200 bg-slate-50 px-4 py-3"
            }, [_createElementVNode("div", _hoisted_18, [_createElementVNode("span", _hoisted_19, _toDisplayString(annotation.creatorName || '系统用户'), 1), _createElementVNode("span", _hoisted_20, _toDisplayString(formatDateTime(annotation.createTime)), 1)]), _createElementVNode("p", _hoisted_21, _toDisplayString(annotation.content), 1)]);
          }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_22, " 暂无批注 "))])], 64)) : _createCommentVNode("", true)]), displayItem.value && displayItem.value.status !== 'COMPLETED' ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("button", {
            onClick: handleComplete,
            class: "px-5 py-2.5 bg-green-600 text-white rounded-lg hover:bg-green-700"
          }, " 标记完成 ")])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      })])), (_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(_Transition, {
        name: "modal"
      }, {
        default: _withCtx(() => [_createVNode(AppModal, {
          visible: showAnnotationDialog.value,
          size: "lg",
          "z-index": 60,
          "panel-class": "mx-4",
          onClose: closeAnnotationDialog
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_24, [_cache[13] || (_cache[13] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "添加批注", -1)), _createElementVNode("button", {
            type: "button",
            onClick: closeAnnotationDialog,
            class: "p-1.5 text-slate-400 hover:text-slate-600",
            disabled: annotationSubmitting.value
          }, [...(_cache[12] || (_cache[12] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))], 8, _hoisted_25)]), _createElementVNode("div", _hoisted_26, [_cache[14] || (_cache[14] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, [_createTextVNode(" 批注内容 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => annotationContent.value = $event),
            rows: "5",
            maxlength: "2000",
            class: "form-textarea",
            placeholder: "请输入批注内容",
            autofocus: ""
          }, null, 512), [[_vModelText, annotationContent.value]]), _createElementVNode("div", _hoisted_27, [_createElementVNode("span", _hoisted_28, _toDisplayString(annotationContent.value.length) + "/2000", 1)])]), _createElementVNode("div", _hoisted_29, [_createElementVNode("button", {
            type: "button",
            onClick: closeAnnotationDialog,
            disabled: annotationSubmitting.value,
            class: "px-5 py-2.5 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 disabled:opacity-50"
          }, " 取消 ", 8, _hoisted_30), _createElementVNode("button", {
            type: "button",
            onClick: handleAddAnnotation,
            disabled: annotationSubmitting.value || !annotationContent.value.trim(),
            class: "px-5 py-2.5 bg-primary-700 text-white rounded-lg hover:bg-primary-800 disabled:opacity-50 disabled:cursor-not-allowed inline-flex items-center gap-2"
          }, [annotationSubmitting.value ? (_openBlock(), _createElementBlock("svg", _hoisted_32, [...(_cache[15] || (_cache[15] = [_createElementVNode("circle", {
            class: "opacity-25",
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            "stroke-width": "4"
          }, null, -1), _createElementVNode("path", {
            class: "opacity-75",
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          }, null, -1)]))])) : _createCommentVNode("", true), _cache[16] || (_cache[16] = _createTextVNode(" 确认 ", -1))], 8, _hoisted_31)])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      })]))], 64);
    };
  }
};